import {Component, Input} from '@angular/core';
import {NgOptimizedImage} from "@angular/common";

@Component({
    selector: 'user-avatar',
    templateUrl: './user-avatar.component.html',
    styleUrls: ['./user-avatar.component.scss'],
    imports: [
        NgOptimizedImage
    ]
})
export class UserAvatarComponent {
    @Input() name: string;
    @Input() src: string | null = null;
    @Input() alt: string | null = null;
    @Input() size: number = 24;

    getAvatarText() {
        return this.name.split(' ').map((name) => name[0]).join('');
    }
}
